export const isAiFeedbackEnabled = (): boolean =>
  process.env.REACT_APP_ENV === "production";
